import { createElement } from 'react';

import type { ViewSetupRequirement } from '@/lib/databases/view-requirements';

type DatabaseViewSetupProps = {
  requirement: ViewSetupRequirement;
  disabled?: boolean;
  onAddColumn: () => void;
};

function stopBubble(event: { stopPropagation: () => void }) {
  event.stopPropagation();
}

export function DatabaseViewSetup({
  requirement,
  disabled,
  onAddColumn,
}: DatabaseViewSetupProps) {
  return createElement(
    'div',
    {
      className: 'cs-db-view-setup',
      onMouseDown: stopBubble,
      onKeyDownCapture: stopBubble,
    },
    createElement('h3', { className: 'cs-db-view-setup-title' }, requirement.title),
    createElement('p', { className: 'cs-db-view-setup-desc' }, requirement.description),
    createElement(
      'button',
      {
        type: 'button',
        className: 'cs-db-view-setup-btn',
        disabled,
        onClick: () => onAddColumn(),
        onMouseDown: stopBubble,
      },
      requirement.addButtonLabel,
    ),
  );
}
